import * as React from "react";
import type { SVGProps } from "react";
const SvgIconAdd = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.87 1.08c-.12.02-.18.06-.27.15-.1.1-.14.17-.16.3-.01.06-.02.96-.02 2.98v2.88H4.47c-2.93 0-2.95 0-3.04.03-.15.06-.28.2-.34.34l-.02.2c0 .1 0 .14.04.22q.11.25.36.33c.06.01.53.02 3.01.02h2.94v2.92c0 2.05 0 2.96.02 3.02.02.13.07.2.16.3q.21.21.5.16c.13-.03.2-.07.3-.16.1-.1.14-.17.16-.3.01-.06.02-.97.02-3.02V8.53h2.94c2.48 0 2.95 0 3.01-.02q.25-.08.36-.33c.04-.08.04-.11.04-.22q0-.13-.02-.2c-.06-.15-.2-.28-.34-.34-.1-.03-.11-.03-3.04-.03H8.58V4.51c0-2.02 0-2.92-.02-2.98-.02-.13-.07-.2-.16-.3-.1-.1-.17-.13-.3-.16-.1-.02-.11-.02-.23 0"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconAdd;
